// this page created by akash-ak
import { useRef, useEffect, useState } from "react";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";

const Table = ({ setselected_item_data, list_data, po_status }) => {
  const createNewRow = () => ({
    item_code: "",
    item: {},
    required_by: "",
    quantity: 0,

  });

  const tableRef = useRef();
  const dropdownRef = useRef();
  const [rowsPerPage] = useState(10);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [item_list, setitem_list] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rows, setRows] = useState([createNewRow()]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [search_input, setsearch_input] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [focusedCell, setFocusedCell] = useState({ rowIndex: null, field: null });
  const isAllSelected = rows.length > 0 && selectedRows.length === rows.length;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allRowIndices = rows.map((_, index) => index);
      setSelectedRows(allRowIndices);
    } else {
      setSelectedRows([]);
    }
  };

  const getItemdata = async (newOffset = 0, searchText = "") => {
    const requestBody = {
      start: newOffset,
      search_input: {
        po_name: searchText || ""
      }
    };

    const res = await list_data(requestBody);

    const PurchaseOrder = res?.data?.data?.purchase_order || [];
    console.log(PurchaseOrder, "PurchaseOrder");

    if (newOffset === 0) {
      setitem_list(PurchaseOrder);
    } else {
      setitem_list((prev) => [...prev, ...PurchaseOrder]);
    }
    setHasMore(PurchaseOrder.length === 20);
  };

  const updateRow = (index, field, value) => {
    console.log(index, field, value, "index, field, value");

    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
    setselected_item_data(updatedRows)
  };

  const toggleRowSelection = (index) => {
    setSelectedRows((prev) => prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]);
  };

  const handleAddRow = () => {
    const newRows = [...rows, createNewRow()];
    setRows(newRows);
    setselected_item_data(newRows);
    const lastPage = Math.ceil(newRows.length / rowsPerPage);
    if (currentPage !== lastPage) {
      setCurrentPage(lastPage);
    }
  };

  const handleDeleteSelectedRows = () => {
    const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
    setRows(updatedRows);
    setselected_item_data(updatedRows);
    setSelectedRows([]);
    const lastPage = Math.ceil(updatedRows.length / rowsPerPage);
    if (currentPage > lastPage) {
      setCurrentPage(lastPage);
    }
  };

  useEffect(() => {
    getItemdata(0, "");
  }, []);

  useEffect(() => {
    const dropdown = dropdownRef.current;
    if (!dropdown) return;
    const handleScroll = () => {
      if (dropdown.scrollTop + dropdown.clientHeight >= dropdown.scrollHeight - 10 && hasMore) {
        const newOffset = offset + 20;
        setOffset(newOffset);
        getItemdata(newOffset, search_input);
      }
    };
    dropdown.addEventListener("scroll", handleScroll);
    return () => dropdown.removeEventListener("scroll", handleScroll);
  }, [offset, hasMore, search_input]);

  useEffect(() => {
    const cols = tableRef.current.querySelectorAll("th");
    cols.forEach((col) => {
      const resizer = document.createElement("div");
      resizer.className = "resizer";
      col.appendChild(resizer);

      let x = 0;
      let w = 0;

      const onMouseDown = (e) => {
        x = e.clientX;
        w = col.offsetWidth;

        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      };

      const onMouseMove = (e) => {
        const dx = e.clientX - x;
        col.style.width = `${w + dx}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      resizer.addEventListener("mousedown", onMouseDown);
    });
  }, []);

  return (
<div
  className="row"
  style={{
    border: "1px solid #00000059",
    borderRadius: "5px",
    marginBottom: "20px"
  }}
>
      <div className="col-12">
        <p className="boxLabel m-0">Gate Entry Details</p>
      </div>
      <div className="">
        <table className="table table-bordered mb-1" ref={tableRef}>
          <thead className="tableHead1">
            <tr>
              {["Action", "S.No", "Purchase Orders", "Purchase Receipt", "Box",].map((title, i) => {
                const defaultWidths = {
                  "Action": "20px",
                  "S.No": "20px",
                  "Purchase Orders": "210px",
                  "Purchase Receipt": "80px",
                  "Quantity": "100px",

                };

                return (
                  <th
                    key={i}
                    style={{
                      fontSize: '7px',
                      position: "relative",
                      textAlign: title === "Action" || title === "S.No" ? "center" : "left",
                      width: defaultWidths[title] || "150px",
                      minWidth: defaultWidths[title] || "150px",
                    }}
                  >
                    {title === "Action" ? (
                      <input
                        type="checkbox"
                        className="form-check-input"
                        style={{ backgroundColor: isAllSelected ? "#270b79" : "", borderColor: isAllSelected ? "#270b79" : "", fontSize: '15px' }}
                        checked={isAllSelected}
                        onChange={handleSelectAll}
                      />
                    ) : (
                      title
                    )}
                  </th>
                );
              })}
            </tr>
          </thead>

          <tbody>
            {currentRows.map((row, index) => {
              const globalIndex = indexOfFirstRow + index;
              return (
                <tr key={globalIndex}>
                  <td className="p-0" style={{ cursor: 'pointer' }}>
                    <p className="m-0" style={{ position: 'relative', top: "5px" }}>
                      {selectedRows.includes(globalIndex) ? (
                        <span onClick={() => toggleRowSelection(globalIndex)}>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            style={{ backgroundColor: "#270b79", fontSize: '15px', borderColor: '#270b79' }}
                            checked
                          />
                        </span>
                      ) : (
                        <span onClick={() => toggleRowSelection(globalIndex)}>
                          <input type="checkbox" className="form-check-input" style={{ fontSize: '15px' }} />
                        </span>
                      )}
                    </p>
                  </td>
                  <td style={{
                    textAlign: "center",
                    fontSize: '0.8rem',
                    padding: '0.5rem'
                  }}>
                    {globalIndex + 1}
                  </td>
                  <td className="p-0 d-flex justify-content-center" style={{ position: "relative", border: focusedCell.rowIndex === globalIndex && focusedCell.field === 'item_code' ? '0.3px solid #270b79' : '' }}>
                    <input
                      type="text"
                      className="form-control tableinput noborder"
                      style={{ fontSize: '0.8rem' }}
                      onFocus={() => { setShowDropdown(globalIndex); setFocusedCell({ rowIndex: globalIndex, field: 'item_code' }) }}
                      onBlur={() => { setTimeout(() => setShowDropdown(false), 300) }}
                      onChange={(e) => {
                        setsearch_input(e.target.value);
                        setOffset(0);
                        getItemdata(0, e.target.value);
                        updateRow(globalIndex, "item_code", e.target.value);
                      }}
                      value={row.item.item_code || row.item_code}
                    />
                    <div
                      ref={dropdownRef}
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        maxHeight: showDropdown === globalIndex ? "200px" : "0",
                        display: showDropdown === globalIndex ? '' : 'none',
                        overflowY: "auto",
                        background: "white",
                        border: showDropdown === globalIndex ? "1px solid #ccc" : "",
                        zIndex: 10,
                      }}
                    >
                      {item_list.map((item, idx) => (
                        <div key={idx}
                          className="text-start"
                          onClick={() => {
                            updateRow(globalIndex, "item", item);
                            updateRow(globalIndex, "item_code", item.name);
                            setsearch_input("");
                            setShowDropdown(false);
                          }}
                          style={{
                            padding: "8px",
                            cursor: "pointer",
                            borderBottom: "1px solid #eee",
                          }}
                        >
                          <p className="m-0">
                            {item.name}
                          </p>
                          <div style={{ fontSize: '10px' }}>
                            {item?.company}, {item?.vendor}
                          </div>
                        </div>
                      ))}
                      {!hasMore && item_list.length === 0 && (
                        <div style={{ padding: "8px", color: "#888" }}>No results</div>
                      )}
                    </div>
                  </td>
                  <td className="p-0"><input type="text" className="form-control tableinput noborder" style={{ fontSize: '0.8rem' }} readOnly value={row.item.item_name} /></td>
                  <td className="p-0 d-flex justify-content-center"
                    style={{
                      border: focusedCell.rowIndex === globalIndex && focusedCell.field === 'quantity' ? '0.3px solid #270b79' : ''
                    }}>
                    <input
                      type="text"
                      className="form-control tableinput noborder"
                      style={{ fontSize: '0.8rem' }}
                      min={1}
                      onFocus={() => setFocusedCell({ rowIndex: globalIndex, field: 'quantity' })}
                      onBlur={() => setFocusedCell({ rowIndex: null, field: null })}
                      value={row.quantity}
                      onChange={(e) => updateRow(globalIndex, "quantity", e.target.value)}
                    />
                  </td>

                  {/* <td className="p-0"><input type="text" className="form-control tableinput noborder" style={{ fontSize: '0.8rem' }} readOnly value={row.item.stock_uom} /></td> */}
                  {/* <td className="p-0"><input type="text" className="form-control tableinput noborder" style={{ fontSize: '0.8rem' }} readOnly value={!row.item?.buying_price ? '' : `₹${row.item.buying_price}`} /></td> */}
                  {/* <td className="p-0"><input type="text" className="form-control tableinput noborder" style={{ fontSize: '0.8rem' }} readOnly value={!row.item?.buying_price ? '' : `₹${row.item.buying_price * row.quantity}`} /></td> */}
                </tr>
              );
            })}
          </tbody>
        </table>
        <div className="d-flex pb-2 justify-content-between align-items-center">
          <div className="d-flex" style={{ gap: '4px' }}>
            {selectedRows.length > 0 && po_status == '' && (
              <Button
                onClick={handleDeleteSelectedRows}
                className="customdeletebtn "
                iconName="MdDeleteOutline"
                iconSize={12}
              >
                Delete
              </Button>
            )}
            {selectedRows.length == 0 && po_status == '' && (
              <Button
                onClick={handleAddRow}
                className="Addrowdesign"
                iconName="FiPlus"
                iconSize={12}
                iconWrapperStyle={{ backgroundColor: '#ff8d5c', padding: '1px', display: 'flex' }}
              >
                Add Row
              </Button>
            )}
            <Button
              className="createbtn d-flex"
              style={{ gap: '2px', height: '28px' }}
              iconName="MdOutlineFileDownload"
              iconSize={12}
            >
              Download
            </Button>
          </div>

          <div className={`${rows.length < 11 ? "d-none" : "d-flex"} align-items-center centerpagination`} style={{ gap: '5px' }}>
            <Pagination
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              pageSize={rowsPerPage}
              totalrecords={rows.length}
            />
          </div>

          <div className={`${rows.length < 11 ? "d-none" : "d-flex"}`}>
            <span className="px-2" style={{ fontSize: '12px', color: '#270B79' }}>
              Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, rows.length)} of {rows.length} entries
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Table;